import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {OidcSecurityService} from "angular-auth-oidc-client";
import {catchError} from "rxjs/operators";
import {forkJoin, throwError} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  developingMode = false;
  api = 'https://engine.jobino.elimedi.com';

  constructor(private http: HttpClient,
              private cookieService: CookieService,
              public oidcSecurityService: OidcSecurityService) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  currentDirection = 'rtl';

  onSetLanguage(language, lan_id) {
    this.cookieService.set('dir', language)
    this.cookieService.set('lang', lan_id);
  }

  apiCall(method, address, body) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: this.cookieService.get('lang'),
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    // console.log(this.oidcSecurityService.getToken())
    // this.oidcSecurityService.forceRefreshSession().subscribe((res: any) => {
    //   console.log('-----------------',res)
    //   if(res){
    //     this.oidcSecurityService.revokeAccessToken(res.accessToken).subscribe((res: any) => {
    //       console.log('++++++++++++++++++++',res)
    //       console.log(this.oidcSecurityService.getToken())
    //     })
    //   }
    //
    // })
    // console.log(this.oidcSecurityService.getRefreshToken())
    // this.oidcSecurityService.stsCallback$().subscribe((res:any)=>{
    //   console.log('................refresh.......................',res)
    // })
    // console.log(this.oidcSecurityService.getToken())

    if (method == 'post') {
      return this.http.post(this.api + address, body, {headers}).pipe(
        catchError(this.handleError)
      );
    } else if (method == 'get') {
      return this.http.get(this.api + address, {headers}).pipe(
        catchError(this.handleError)
      );
    } else if (method == 'delete') {
      return this.http.delete(this.api + address, {headers}).pipe(
        catchError(this.handleError)
      );
    } else if (method == 'put') {
      return this.http.put(this.api + address, body, {headers}).pipe(
        catchError(this.handleError)
      );
    }
  }

  handleError(error: any) {
    // console.log("lalalalalalalala", error.status);
    if (error.status == 401) {
      // this.oidcSecurityService.forceRefreshSession().subscribe((res: any) => {
      //   console.log(res)
      //   if(res){
      //     this.oidcSecurityService.revokeAccessToken(res.accessToken).subscribe((res: any) => {
      //       console.log(res)
      //       console.log(this.oidcSecurityService.getToken())
      //     })
      //   }
      //
      // })
      // console.log(this.oidcSecurityService.getToken())
      // this.oidcSecurityService.revokeRefreshToken(this.oidcSecurityService.getRefreshToken()).subscribe((res:any)=>{
      //   console.log(res)
      //
      // })
    }

    return throwError(error);
  }

  // GetLanguages() {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/admin/GetLanguages', {headers});
  // }

  // RegisterConfirm() {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/Account/RegisterConfirm', {headers});
  // }

  // GetImage(Md5) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang')
  //   });
  //
  //   return this.http.get(this.api + '/api/Media/GetImage/' + Md5, {headers});
  // }

  // GetCountries() {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/Admin/GetCountries/', {headers});
  // }
  //
  // GetProvinces(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/Admin/GetProvinces/' + id, {headers});
  // }
  //
  // Getcities(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/Admin/GetCities/' + id, {headers});
  // }

// ----------------------------------------------------------------------------------------------------------------------------------------
//   GetCategories(id) {
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       lang: this.cookieService.get('lang'),
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.get(this.api + '/api/Admin/GetCategories/' + id, {headers});
//   }

  // EditCategory(id) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/Admin/EditCategory/' + id, {headers});
  // }

  // AddCategory(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/Admin/AddCategory/', body, {headers});
  // }
  //
  // UpdateCategory(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.put(this.api + '/api/Admin/UpdateCategory/', body, {headers});
  // }
  //
  // DeleteCategory(id) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/Admin/DeleteCategory/' + id, {headers});
  // }
  //
  // GetRequests(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/Admin/GetRequests/', body, {headers}).pipe(
  //     catchError(this.handleError)
  //   );
  // }
  //
  // GetMaxValue() {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/Admin/GetMaxValue/', {headers});
  // }
  //
  //
  // GetRequest(id){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/Admin/GetRequest/'+id, {headers});
  // }
  //
  // ConfirmReqest(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/Admin/ConfirmReqest/'+id, {}, {headers});
  // }
  //
  // RemoveRequest(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.delete(this.api + '/api/admin/RemoveRequest/' + id, {headers});
  // }


}
